module.exports = __webpack_public_path__ + "media/customizations/riverland/back-bbac9539fc9eb3949eaeb84f9da41dff.jpg";